export default class ETR {
    constructor() {
        this.groups = document.querySelectorAll(".js-etr-pre-orders");
        if (this.groups) {
            this.fetchAll();
        }
    }

    fetchETR(group) {
        return fetch(group.dataset.url, {
            credentials: "include",
        }).then(response => response.json()).then((data) => {
            if (data.nbPreOrder !== undefined) {
                group.innerHTML = `x${data.nbPreOrder}`;
            }
        }).catch((error) => {
            group.innerHTML = "n/a";
            console.log(`There has been a problem with your fetch operation: ${error.message}`);
        });
    }

    fetchAll() {
        let promise = null;
        this.groups.forEach((group) => {
            if (promise === null) {
                promise = this.fetchETR(group);
            } else {
                promise = promise.then(() => this.fetchETR(group));
            }
        });
    }
}
